<template>
  <ColorPicker
    :theme="generalStore.light ? 'light' : 'dark'"
    :color="defaultColor"
    :template-label="$t('color_picker.template_colors')"
    :predefined-label="$t('color_picker.predefined_colors')"
    :colors-default="presetColors"
    :template-colors="templateColors"
    @change-color="emits('color-change', $event)"
    @start-selecting-color="generalStore.colorSelecting = true"
    @stop-selecting-color="generalStore.colorSelecting = false"
  />
</template>

<script setup lang="ts">
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { useColorsStore } from "@/stores/colors";
  import { useGeneralStore } from "@/stores/generalStore";
  import { ColorPicker } from "@topol/twig-ui";
  import { computed, ref, onMounted } from "vue";

  type Props = {
    defaultColor?: string;
  };

  withDefaults(defineProps<Props>(), {
    defaultColor: undefined,
  });

  const emits = defineEmits(["color-change"]);

  const mjmlStore = useMjmlStore();
  const colorsStore = useColorsStore();
  const generalStore = useGeneralStore();

  const presetColors = ref([
    "rgba(0,0,0,0)",
    "#D0021B",
    "#F5A623",
    "#F8E71C",
    "#8B572A",
    "#7ED321",
    "#417505",
    "#BD10E0",
    "#9013FE",
    "#4A90E2",
    "#50E3C2",
    "#B8E986",
    "#000000",
    "#4A4A4A",
    "#9B9B9B",
    "#FFFFFF",
  ]);

  const colors = computed(() => colorsStore.colors);
  const templateColorsRef = ref<string[]>(getAllColorsFromTemplate());

  const templateColors = computed({
    get() {
      return templateColorsRef.value;
    },
    set(value) {
      templateColorsRef.value = value;
    },
  });

  function getAllColorsFromTemplate() {
    const templateString = JSON.stringify(mjmlStore.getMjml()).toLowerCase();
    const hexColorPattern = /#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})/g;
    const colors = templateString.match(hexColorPattern);
    return [...new Set(colors)];
  }

  function setColorsUsedInTemplate() {
    templateColors.value = getAllColorsFromTemplate();
  }

  onMounted(() => {
    if (colors.value && colors.value.length > 0) {
      presetColors.value = [];
      presetColors.value.push(...colors.value);
    }
  });
</script>
